import { render, staticRenderFns } from "./CustomerAcquisitionEmailPreview.vue?vue&type=template&id=bc48bd54&scoped=true&"
import script from "./CustomerAcquisitionEmailPreview.vue?vue&type=script&lang=ts&"
export * from "./CustomerAcquisitionEmailPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerAcquisitionEmailPreview.vue?vue&type=style&index=0&id=bc48bd54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc48bd54",
  null
  
)

export default component.exports